import React from "react";
import { Link } from "react-router-dom";

export default () => (
  <h4 className="no-orders-msg">
    You haven't sold any cards yet! Click{" "}
    <Link to="/new-order/enter-cards" className="buy-or-sell-link">
      here
    </Link>{" "}
    to start selling gift cards.
  </h4>
);
